module.exports = __webpack_public_path__ + "img/fond_racing_maze.931ee44a.jpg";